export default class TableProperty {
  #name;
  #type;
  #isNested;

  constructor(name, type, isNested = false) {
    this.#name = name.replaceAll(' ', '_');
    this.#type = type;
    this.#isNested = isNested;
  }

  setName(name) {
    this.#name = name.replaceAll(' ', '_');
  }

  getName() {
    return this.#name;
  }

  setType(type) {
    this.#type = type;
  }

  getType() {
    return this.#type;
  }

  setAsNested() {
    this.#isNested = true;
  }

  isNested() {
    return this.#isNested;
  }
}
